<mat-card class="table-container mat-elevation-z8">
  <h4>View usage data:</h4>
  <div class="date-picker-container">
    <mat-form-field appearance="outline">
      <mat-label>From</mat-label>
      <input matInput [matDatepicker]="fromPicker" [(ngModel)]="fromDate" (ngModelChange)="applyDateFilter()">
      <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
      <mat-datepicker #fromPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>To</mat-label>
      <input matInput [matDatepicker]="toPicker" [(ngModel)]="toDate" (ngModelChange)="applyDateFilter()">
      <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
      <mat-datepicker #toPicker></mat-datepicker>
    </mat-form-field>
    <div class="export-buttons" style="position: absolute; top: 70px; right: 40px;">
      <mat-button-toggle-group [value]="transactionView" (change)="setTransactionView($event.value)" class="view-toggle-group">
        <mat-button-toggle value="webapp">
          <mat-icon>web</mat-icon> Web-APP
        </mat-button-toggle>
        <mat-button-toggle value="m2m">
          <mat-icon>swap_horiz</mat-icon> M2M
        </mat-button-toggle>
        <mat-button-toggle value="webai">
          <mat-icon>psychology</mat-icon> Web AI
        </mat-button-toggle>
      </mat-button-toggle-group>
      <button mat-button class="custom-switch-button" (click)="exportToCSV()">
      <mat-icon>table_view</mat-icon>
      EXPORT TO CSV
      </button>
      <button mat-button class="custom-switch-button" (click)="exportToPDF()">
      <mat-icon>description</mat-icon>
      EXPORT TO PDF
      </button>
    </div>
  </div>
  <div class="filter-container">
         <mat-form-field class="small-rounded-filter" appearance="outline">
        <mat-label>Equipment Code</mat-label>
        <mat-select [(ngModel)]="filters.equipment_code" (ngModelChange)="applyFilters()" multiple [compareWith]="compareFn">
          <mat-option>
            <ngx-mat-select-search
              [formControl]="equipmentFilterCtrl"
              placeholderLabel="Search..."
              noEntriesFoundLabel="No match found">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let code of getFilteredEquipments()" [value]="code">
            {{ code }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="small-rounded-filter" appearance="outline">
        <mat-label>Make</mat-label>
        <mat-select [(ngModel)]="filters.make" (ngModelChange)="applyFilters()" multiple [compareWith]="compareFn">
          <mat-option>
            <ngx-mat-select-search
              [formControl]="makeFilterCtrl"
              placeholderLabel="Search..."
              noEntriesFoundLabel="No match found">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let make of getFilteredMakes()" [value]="make">
            {{ make }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="small-rounded-filter" appearance="outline" style="min-width: 220px;">
        <mat-label>Model</mat-label>
        <mat-select [(ngModel)]="filters.model" (ngModelChange)="applyFilters()" multiple [compareWith]="compareFn">
          <mat-option>
            <ngx-mat-select-search
              [formControl]="modelFilterCtrl"
              placeholderLabel="Search..."
              noEntriesFoundLabel="No match found">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let model of getFilteredModels()" [value]="model">
            {{ model }}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field class="small-rounded-filter" appearance="outline">
        <mat-label>User ID</mat-label>
        <mat-select [(ngModel)]="filters.user_id" (ngModelChange)="applyFilters()" multiple [compareWith]="compareFn">
          <mat-option>
            <ngx-mat-select-search
              [formControl]="userIdFilterCtrl"
              placeholderLabel="Search..."
              noEntriesFoundLabel="No match found">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let userId of getFilteredUserIds()" [value]="userId">
            {{ userId }}
          </mat-option>
        </mat-select>
      </mat-form-field>

    <mat-form-field class="small-rounded-filter" appearance="outline">
      <mat-label>Response contains</mat-label>
      <input matInput [(ngModel)]="filters.response" (ngModelChange)="applyFilters()" placeholder="Enter response text">
    </mat-form-field>

    <mat-form-field class="small-rounded-filter" appearance="outline">
      <mat-label>User input contains</mat-label>
      <input matInput [(ngModel)]="filters.user_input" (ngModelChange)="applyFilters()" placeholder="Enter user input text">
    </mat-form-field>

    <mat-form-field class="small-rounded-filter" appearance="outline">
      <mat-label>Response Feedback</mat-label>
      <mat-select [(ngModel)]="filters.feedBack" (selectionChange)="applyFilters()" multiple>
        <mat-option>
          <ngx-mat-select-search
            [formControl]="feedbackFilterCtrl"
            placeholderLabel="Search..."
            noEntriesFoundLabel="No match found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let feedback of getFilteredFeedbacks()" [value]="feedback">
          {{ feedback }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="small-rounded-filter" appearance="outline">
      <mat-label>Feedback Reason</mat-label>
      <mat-select [(ngModel)]="filters.feedBackReason" (selectionChange)="applyFilters()" multiple>
        <mat-option>
          <ngx-mat-select-search
            [formControl]="feedbackReasonFilterCtrl"
            placeholderLabel="Search..."
            noEntriesFoundLabel="No match found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let reason of getFilteredFeedbackReasons()" [value]="reason">
          {{ reason }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="small-rounded-filter" appearance="outline">
      <mat-label>Feedback Contains</mat-label>
      <input matInput [(ngModel)]="filters.feedBackDetails" (ngModelChange)="applyFilters()" placeholder="Enter feedback details">
    </mat-form-field>
        
    <mat-form-field  *ngIf="transactionView === 'm2m'" class="small-rounded-filter" appearance="outline">
    <mat-label>Applications</mat-label>
    <mat-select [(ngModel)]="filters.applications" (ngModelChange)="applyFilters()" multiple [compareWith]="compareFn">
      <mat-option>
        <ngx-mat-select-search
          [formControl]="applicationsFilterCtrl"
          placeholderLabel="Search..."
          noEntriesFoundLabel="No match found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let application of getFilteredApplications()" [value]="application">
        {{ application }}
      </mat-option>
    </mat-select>
  </mat-form-field>

    <button mat-raised-button (click)="clearAllFilters()" class="clear-button" >Clear All Filters</button>
  </div>
  <h4>Search results:</h4>
  <table mat-table [dataSource]="dataSource || []" class="full-width-table" matSort>
    <ng-container matColumnDef="start_timestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Date</th>
      <td mat-cell *matCellDef="let element" class="truncate-cell">{{ element.start_timestamp }}</td>
    </ng-container>

    <ng-container matColumnDef="response_feedback">
      <th mat-header-cell *matHeaderCellDef class="header-cell">Response Feedback</th>
      <td mat-cell *matCellDef="let element">
        <span [ngClass]="{
          'feedback-correct': element.response_feedback === 'Correct',
          'feedback-incorrect': element.response_feedback === 'Incorrect',
          'feedback-na': element.response_feedback === 'N/A'
        }">{{element.response_feedback}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="feedback_reason">
      <th mat-header-cell *matHeaderCellDef class="header-cell">Feedback Reason</th>
      <td mat-cell *matCellDef="let element">
        <span>{{element.feedback_reason}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="feedback_details">
      <th mat-header-cell *matHeaderCellDef class="header-cell">Feedback Details</th>
      <td mat-cell *matCellDef="let element">{{element.feedback_details}}</td>
    </ng-container>

    <ng-container matColumnDef="equipment_code">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Equipment</th>
    <td mat-cell *matCellDef="let element" class="truncate-cell">{{element.equipment_code}}</td>
    </ng-container>

    <ng-container matColumnDef="make">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Make</th>
      <td mat-cell *matCellDef="let element" class="truncate-cell">{{element.make}}</td>
    </ng-container>

    <ng-container matColumnDef="model">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Model</th>
      <td mat-cell *matCellDef="let element" class="truncate-cell">{{element.model}}</td>
    </ng-container>

 
    <ng-container matColumnDef="user_id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">UserID</th>
      <td mat-cell *matCellDef="let element" class="truncate-cell">{{element.user_id}}</td>
    </ng-container>

    <ng-container matColumnDef="original_response">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Original Response</th>
      <td mat-cell *matCellDef="let element" class="truncate-cell">{{element.original_response}}</td>
    </ng-container>

    <ng-container matColumnDef="response">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Response</th>
      <td mat-cell *matCellDef="let element" class="truncate-cell">{{element.response}}</td>
    </ng-container>

    <ng-container matColumnDef="user_input">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Question</th>
      <td mat-cell *matCellDef="let element" class="truncate-cell">{{element.user_input}}</td>
    </ng-container>
    
    <ng-container matColumnDef="expandRecord">
      <th mat-header-cell *matHeaderCellDef class="header-cell">Actions</th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-raised-button
          color="primary"
          class="expand-record-button"
          (click)="openTransactionModal(element)">
          <mat-icon>visibility</mat-icon>
          EXPAND RECORD
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (mouseover)="hoveredRow = row" (mouseleave)="hoveredRow = null"></tr>
  </table>
  <div *ngIf="isLoading" class="loading-container">
    <div style="position: fixed; top: 22%; left: 60%; transform: translate(-50%, -50%); display: flex; flex-direction: column; align-items: center;">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  </div>
  <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
  <div *ngIf="!dataSource.data || dataSource.data.length === 0" class="no-data-container">
    <img src="assets/no_entry_found.png" alt="No entry found" class="no-entry-icon">
    <p>Charging Data, please wait!</p>
  </div>
</mat-card>